import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const OrderDetailInfo = () => {
  const { pk, id } = useParams();
  const [orderData, setOrderInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  
      useEffect(() => {
        const fetchOrderInfo = async () => {
          try {
            const response = await axios.get(`https://terracharms.com/get_order2/${pk}/${id}/`);
            setOrderInfo(response.data);
          }catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOrderInfo();
  }, [pk, id]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="row mb-5 order-info-wrap">
      <div className="col-md-6 col-lg-4">
        <article className="icontext align-items-start">
          <span className="icon bg-green-70 icon-sm rounded-circle alert-success bg-green-700">
            <i className="text-success fas fa-user text-white"></i>
          </span>
          <div className="text">
            <h6 className="mb-1">Customer</h6>
            <p className="mb-1">
              {orderData.User_Name} <br />
              <a href={`Mail to:${orderData.User_email}`}>{orderData.User_email}</a>
            </p>
          </div>
        </article>
      </div>
      <div className="col-md-6 col-lg-4">
        <article className="icontext align-items-start">
          <span className="icon icon-sm bg-green-700 rounded-circle alert-success">
            <i className="text-success fas fa-truck-moving text-white"></i>
          </span>
          <div className="text">
            <h6 className="mb-1">Order info</h6>
            <p className="mb-1">
              Shipping: {orderData.Shipping} <br />
              Pay method: {orderData["Payment Method"]}
            </p>
          </div>
        </article>
      </div>
      <div className="col-md-6 col-lg-4">
        <article className="icontext align-items-start">
          <span className="icon icon-sm rounded-circle alert-success bg-green-700">
            <i className="text-success fas fa-map-marker-alt text-white"></i>
          </span>
          <div className="text">
            <h6 className="mb-1">Deliver to</h6>
            <p className="mb-1">
              Address: {orderData.Address}
            </p>
          </div>
        </article>
      </div>
    </div>
  );
};

export default OrderDetailInfo;
